export const AUTH_STORAGE_KEY = "chord-keeper-auth";
export const APP_STORAGE_KEY = "chord-keeper-app";